import { TenantEntity } from '@/class/model/TenantEntity'
import { getMscSupplement } from '@/api/seaExport/mscSupplement'

export class MscSupplement extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'MscSupplement'
  }
  get mstBooking() {
    return this._data.mstBooking
  }
  set mstBooking(mstBooking) {
    this._data.mstBooking = mstBooking
  }
  get contractRateMode() {
    return this._data.contractRateMode
  }
  set contractRateMode(contractRateMode) {
    this._data.contractRateMode = contractRateMode
  }

  get freightBl() {
    return this._data.freightBl
  }
  set freightBl(freightBl) {
    this._data.freightBl = freightBl || 0
  }

  get podAgency() {
    return this._data.podAgency
  }
  set podAgency(podAgency) {
    this._data.podAgency = podAgency || 0
  }

  get place0fReceiptCy() {
    return this._data.place0fReceiptCy
  }
  set place0fReceiptCy(place0fReceiptCy) {
    this._data.place0fReceiptCy = place0fReceiptCy
  }

  get place0fReceiptShippingMode() {
    return this._data.place0fReceiptShippingMode
  }
  set place0fReceiptShippingMode(place0fReceiptShippingMode) {
    this._data.place0fReceiptShippingMode = place0fReceiptShippingMode
  }

  get finalDest() {
    return this._data.finalDest
  }
  set finalDest(finalDest) {
    this._data.finalDest = finalDest
  }

  get fnlSubLoc() {
    return this._data.fnlSubLoc
  }
  set fnlSubLoc(fnlSubLoc) {
    this._data.fnlSubLoc = fnlSubLoc
  }

  get fnlTm() {
    return this._data.fnlTm
  }
  set fnlTm(fnlTm) {
    this._data.fnlTm = fnlTm
  }

  get comment() {
    return this._data.comment
  }
  set comment(comment) {
    this._data.comment = comment
  }

  get destinationZipCode() {
    return this._data.destinationZipCode
  }
  set destinationZipCode(destinationZipCode) {
    this._data.destinationZipCode = destinationZipCode
  }

  get consigneeId() {
    return this._data.consigneeId
  }
  set consigneeId(consigneeId) {
    this._data.consigneeId = consigneeId
  }

  get consigneeCode() {
    return this._data.consigneeCode
  }
  set consigneeCode(consigneeCode) {
    this._data.consigneeCode = consigneeCode
  }

  get consigneeVipCode() {
    return this._data.consigneeVipCode
  }
  set consigneeVipCode(consigneeVipCode) {
    this._data.consigneeVipCode = consigneeVipCode
  }

  get consigneeMscCode() {
    return this._data.consigneeMscCode
  }
  set consigneeMscCode(consigneeMscCode) {
    this._data.consigneeMscCode = consigneeMscCode
  }

  get consigneeCompanyCode() {
    return this._data.consigneeCompanyCode
  }
  set consigneeCompanyCode(consigneeCompanyCode) {
    this._data.consigneeCompanyCode = consigneeCompanyCode
  }

  get consigneeInttraCode() {
    return this._data.consigneeInttraCode
  }
  set consigneeInttraCode(consigneeInttraCode) {
    this._data.consigneeInttraCode = consigneeInttraCode
  }

  get consigneeOtherInfo() {
    return this._data.consigneeOtherInfo
  }
  set consigneeOtherInfo(consigneeOtherInfo) {
    this._data.consigneeOtherInfo = consigneeOtherInfo
  }

  get consigneeUseBl() {
    return this._data.consigneeUseBl
  }
  set consigneeUseBl(consigneeUseBl) {
    this._data.consigneeUseBl = consigneeUseBl || 0
  }

  get consigneeBlCompany() {
    return this._data.consigneeBlCompany
  }
  set consigneeBlCompany(consigneeBlCompany) {
    this._data.consigneeBlCompany = consigneeBlCompany
  }

  get consigneeBlAddress() {
    return this._data.consigneeBlAddress
  }
  set consigneeBlAddress(consigneeBlAddress) {
    this._data.consigneeBlAddress = consigneeBlAddress
  }

  get consigneeBlContact() {
    return this._data.consigneeBlContact
  }
  set consigneeBlContact(consigneeBlContact) {
    this._data.consigneeBlContact = consigneeBlContact
  }

  get notifyId() {
    return this._data.notifyId
  }
  set notifyId(notifyId) {
    this._data.notifyId = notifyId
  }

  get notifyCode() {
    return this._data.notifyCode
  }
  set notifyCode(notifyCode) {
    this._data.notifyCode = notifyCode
  }

  get notifyVipCode() {
    return this._data.notifyVipCode
  }
  set notifyVipCode(notifyVipCode) {
    this._data.notifyVipCode = notifyVipCode
  }

  get notifyMscCode() {
    return this._data.notifyMscCode
  }
  set notifyMscCode(notifyMscCode) {
    this._data.notifyMscCode = notifyMscCode
  }

  get notifyCompanyCode() {
    return this._data.notifyCompanyCode
  }
  set notifyCompanyCode(notifyCompanyCode) {
    this._data.notifyCompanyCode = notifyCompanyCode
  }

  get notifyInttraCode() {
    return this._data.notifyInttraCode
  }
  set notifyInttraCode(notifyInttraCode) {
    this._data.notifyInttraCode = notifyInttraCode
  }

  get notifyOtherInfo() {
    return this._data.notifyOtherInfo
  }
  set notifyOtherInfo(notifyOtherInfo) {
    this._data.notifyOtherInfo = notifyOtherInfo
  }

  get notifyUseBl() {
    return this._data.notifyUseBl
  }
  set notifyUseBl(notifyUseBl) {
    this._data.notifyUseBl = notifyUseBl || 0
  }

  get notifyBlCompany() {
    return this._data.notifyBlCompany
  }
  set notifyBlCompany(notifyBlCompany) {
    this._data.notifyBlCompany = notifyBlCompany
  }

  get notifyBlAddress() {
    return this._data.notifyBlAddress
  }
  set notifyBlAddress(notifyBlAddress) {
    this._data.notifyBlAddress = notifyBlAddress
  }

  get notifyBlContact() {
    return this._data.notifyBlContact
  }
  set notifyBlContact(notifyBlContact) {
    this._data.notifyBlContact = notifyBlContact
  }

  get alsoNotifyCode() {
    return this._data.alsoNotifyCode
  }
  set alsoNotifyCode(alsoNotifyCode) {
    this._data.alsoNotifyCode = alsoNotifyCode
  }

  get alsoNotify() {
    return this._data.alsoNotify
  }
  set alsoNotify(alsoNotify) {
    this._data.alsoNotify = alsoNotify
  }

  get alsoNotifyVipCode() {
    return this._data.alsoNotifyVipCode
  }
  set alsoNotifyVipCode(alsoNotifyVipCode) {
    this._data.alsoNotifyVipCode = alsoNotifyVipCode
  }

  get alsoNotifyMscCode() {
    return this._data.alsoNotifyMscCode
  }
  set alsoNotifyMscCode(alsoNotifyMscCode) {
    this._data.alsoNotifyMscCode = alsoNotifyMscCode
  }

  get alsoNotifyCompanyCode() {
    return this._data.alsoNotifyCompanyCode
  }
  set alsoNotifyCompanyCode(alsoNotifyCompanyCode) {
    this._data.alsoNotifyCompanyCode = alsoNotifyCompanyCode
  }

  get alsoNotifyInttraCode() {
    return this._data.alsoNotifyInttraCode
  }
  set alsoNotifyInttraCode(alsoNotifyInttraCode) {
    this._data.alsoNotifyInttraCode = alsoNotifyInttraCode
  }

  get alsoNotifyOtherInfo() {
    return this._data.alsoNotifyOtherInfo
  }
  set alsoNotifyOtherInfo(alsoNotifyOtherInfo) {
    this._data.alsoNotifyOtherInfo = alsoNotifyOtherInfo
  }

  get alsoNotifyUseBl() {
    return this._data.alsoNotifyUseBl
  }
  set alsoNotifyUseBl(alsoNotifyUseBl) {
    this._data.alsoNotifyUseBl = alsoNotifyUseBl || 0
  }

  get alsoNotifyBlCompany() {
    return this._data.alsoNotifyBlCompany
  }
  set alsoNotifyBlCompany(alsoNotifyBlCompany) {
    this._data.alsoNotifyBlCompany = alsoNotifyBlCompany
  }

  get alsoNotifyBlAddress() {
    return this._data.alsoNotifyBlAddress
  }
  set alsoNotifyBlAddress(alsoNotifyBlAddress) {
    this._data.alsoNotifyBlAddress = alsoNotifyBlAddress
  }

  get alsoNotifyBlContact() {
    return this._data.alsoNotifyBlContact
  }
  set alsoNotifyBlContact(alsoNotifyBlContact) {
    this._data.alsoNotifyBlContact = alsoNotifyBlContact
  }

  get shipperId() {
    return this._data.shipperId
  }
  set shipperId(shipperId) {
    this._data.shipperId = shipperId
  }

  get shipperCode() {
    return this._data.shipperCode
  }
  set shipperCode(shipperCode) {
    this._data.shipperCode = shipperCode
  }
  get shipperVipCode() {
    return this._data.shipperVipCode
  }
  set shipperVipCode(shipperVipCode) {
    this._data.shipperVipCode = shipperVipCode
  }

  get shipperMscCode() {
    return this._data.shipperMscCode
  }
  set shipperMscCode(shipperMscCode) {
    this._data.shipperMscCode = shipperMscCode
  }

  get shipperCompanyCode() {
    return this._data.shipperCompanyCode
  }
  set shipperCompanyCode(shipperCompanyCode) {
    this._data.shipperCompanyCode = shipperCompanyCode
  }

  get shipperInttraCode() {
    return this._data.shipperInttraCode
  }
  set shipperInttraCode(shipperInttraCode) {
    this._data.shipperInttraCode = shipperInttraCode
  }

  get shipperOtherInfo() {
    return this._data.shipperOtherInfo
  }
  set shipperOtherInfo(shipperOtherInfo) {
    this._data.shipperOtherInfo = shipperOtherInfo
  }

  get shipperUseBl() {
    return this._data.shipperUseBl
  }
  set shipperUseBl(shipperUseBl) {
    this._data.shipperUseBl = shipperUseBl || 0
  }

  get shipperBlCompany() {
    return this._data.shipperBlCompany
  }
  set shipperBlCompany(shipperBlCompany) {
    this._data.shipperBlCompany = shipperBlCompany
  }

  get shipperBlAddress() {
    return this._data.shipperBlAddress
  }
  set shipperBlAddress(shipperBlAddress) {
    this._data.shipperBlAddress = shipperBlAddress
  }

  get shipperBlContact() {
    return this._data.shipperBlContact
  }
  set shipperBlContact(shipperBlContact) {
    this._data.shipperBlContact = shipperBlContact
  }

  get paymentCode() {
    return this._data.paymentCode
  }
  set paymentCode(paymentCode) {
    this._data.paymentCode = paymentCode
  }

  get paymentVipCode() {
    return this._data.paymentVipCode
  }
  set paymentVipCode(paymentVipCode) {
    this._data.paymentVipCode = paymentVipCode
  }

  get paymentMscCode() {
    return this._data.paymentMscCode
  }
  set paymentMscCode(paymentMscCode) {
    this._data.paymentMscCode = paymentMscCode
  }

  get paymentCompanyCode() {
    return this._data.paymentCompanyCode
  }
  set paymentCompanyCode(paymentCompanyCode) {
    this._data.paymentCompanyCode = paymentCompanyCode
  }

  get paymentInttraCode() {
    return this._data.paymentInttraCode
  }
  set paymentInttraCode(paymentInttraCode) {
    this._data.paymentInttraCode = paymentInttraCode
  }

  get paymentOtherInfo() {
    return this._data.paymentOtherInfo
  }
  set paymentOtherInfo(paymentOtherInfo) {
    this._data.paymentOtherInfo = paymentOtherInfo
  }

  get paymentUseBl() {
    return this._data.paymentUseBl
  }
  set paymentUseBl(paymentUseBl) {
    this._data.paymentUseBl = paymentUseBl || 0
  }

  get paymentBlCompany() {
    return this._data.paymentBlCompany
  }
  set paymentBlCompany(paymentBlCompany) {
    this._data.paymentBlCompany = paymentBlCompany
  }

  get paymentBlAddress() {
    return this._data.paymentBlAddress
  }
  set paymentBlAddress(paymentBlAddress) {
    this._data.paymentBlAddress = paymentBlAddress
  }

  get paymentBlContact() {
    return this._data.paymentBlContact
  }
  set paymentBlContact(paymentBlContact) {
    this._data.paymentBlContact = paymentBlContact
  }

  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }

  async getMscSupplement() {
    const data = this._data
    if (typeof data.mscSupplement !== 'object') {
      data.mscSupplement = await getMscSupplement({ jobUuid: data.uuid }).then(res => res.data)
    }
    return data.mscSupplement
  }
  async reload() {
    await getMscSupplement({ jobUuid: this._data.jobUuid }).then(res => {
      if (res.data) {
        Object.assign(this._data, res.data)
      }
    })
  }
}
